<template>
  <v-container fluid id="contact">
    <v-layout column>
      <v-flex class="display-2 text-xs-center">Contact Us</v-flex>
      <v-divider insert></v-divider>
      <v-container lg4>
        <v-flex>
          <p class="subheading mt-3">
            Any questions or concerns? Any complaints or compliments? Please send
            us an email or give us a call!
          </p>
          <p>
            <i>All calls are toll free because we don't know how to charge tolls
              for a phone call. If you know how, please tell us and we will split
              the profits with you 50/50</i>
          </p>
        </v-flex>
      </v-container>
      <v-container align-center justify-center fluid grid-list-lg4>
        <contact-cards></contact-cards>
        <contact-form></contact-form>
      </v-container>
    </v-layout>
  </v-container>
</template>

<script>
import ContactCards from '@/components/ContactCards.vue';
import ContactForm from '@/components/ContactForm.vue';

export default {
  name: 'Contact',
  props: {
    source: String,
  },
  components: {
    ContactCards,
    ContactForm,
  },
};
</script>

<style scoped></style>
